import { MAX_OFFERS_BEFORE_CAROUSEL } from 'shared/constants/newbuildingCarouselOffers';

import { IIntegrateAdOptions } from '../types';

/**
 * Определяет, будет ли показана карусель на позиции 2 (после 2-го оффера)
 * Это нужно для того, чтобы не показывать SERVICES BANNER в основной выдаче, если карусель уже показана
 */
export const willCarouselBannerBeShown = (
  isNewbuildingOffersWithBannerCarouselVisible: boolean | undefined,
  offersLength: number,
  suggestionFragment: IIntegrateAdOptions['suggestionFragment'],
): boolean => {
  return Boolean(
    isNewbuildingOffersWithBannerCarouselVisible &&
    offersLength >= MAX_OFFERS_BEFORE_CAROUSEL &&
    !suggestionFragment.isSimilar,
  );
};
